import { type ComponentProps } from "react";

import { cn } from "../../utils";

export const Current = ({ ref, className, ...props }: ComponentProps<"li">) => (
  <li ref={ref} className={cn("shrink-0 truncate text-sm font-bold text-primary-40", className)} {...props} />
);
Current.displayName = "BreadcrumbCurrent";

export default Current;
